import { render, staticRenderFns } from "./myGallery.vue?vue&type=template&id=9d127726&scoped=true&"
import script from "./myGallery.vue?vue&type=script&lang=js&"
export * from "./myGallery.vue?vue&type=script&lang=js&"
import style0 from "./myGallery.vue?vue&type=style&index=0&id=9d127726&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d127726",
  null
  
)

export default component.exports